module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step3-9a9af93331dd0e873974facfad6c7281.jpg";